<template>
  <router-view/>
</template>

<script setup>
import {onMounted} from 'vue'
import {useStore} from 'vuex'

const $store = useStore()

const debounce = (fn, delay) => {
  let timer = null
  return function () {
    const context = this
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}
const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16)
    super(callback)
  }
}

onMounted(() => {
  $store.dispatch('initData')
})
</script>

<style>

</style>
